import { Link } from "react-router-dom";
import SubMainContainer from "../UI/SubMainContainer";
import { useState } from "react";
import Accounts from "./Accounts";
import SearchBar from "../Layouts/SearchBar/SearchBar";
import Pagination from "../Customer/Pagination";
import Navigation from "../Views/Setting/Navigation";
import EmployeeData from "../Settings/Employee/EmployeeData";
import ListPackage from "./ListPackage";

const PackagesListPageContent = () => {
  const [searchValue, setSearchValue] = useState("");
  const [keyValue, setKeyValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage, setUsersPerPage] = useState(5);
  const [total_records, setTotalRecords] = useState(0);

  const paginate = (number) => {
    setCurrentPage(number);
  };
  return (
    <SubMainContainer SubMainContainerCustomClass="rightCol">
      <div className="contentContainer">
        <h2>Settings</h2>
        {/* <div className="searchPanel">
          <div className="searchBar">
            <i className="material-symbols-rounded mt-m grey">search</i>
            <input type="search" placeholder="Search plan by name" />
          </div> */}
        <div className="subContent">
          <Navigation />
          <div className="mt-24">
            <div className="boxType1 mt-24">
              {/*<SearchBar*/}
              {/*    placeholder={"Search by plan name"}*/}
              {/*    setSearchValue={setSearchValue}*/}
              {/*    setKeyValue={setKeyValue}*/}
              {/*    searchValue={searchValue}*/}
              {/*    btn_value={""}*/}
              {/*    btn_link={"/CreatePackage"}*/}
              {/*/>*/}

              <ListPackage/>
              {/*<Accounts*/}
                {/*    searchValue={searchValue}*/}
                {/*    keyvalue={keyValue}*/}
                {/*    setKeyValue={setKeyValue}*/}
                {/*/>*/}
                <Pagination
                    paginate={paginate}
                    currentPage={currentPage}
                    usersPerPage={usersPerPage}
                    total_records={total_records}
                    setUsersPerPage={setUsersPerPage}
                    setCurrentPage={setCurrentPage}
                />

            </div>
          </div>

        </div>

      </div>
    </SubMainContainer>
  );
};

export default PackagesListPageContent;
